(function () {
        const redirects = {
          'long formal dresses': '/collections/long-formal-dresses',
          'red gown': '/collections/red-dresses',
          'red dresses': '/collections/red-dresses',
          'clearance': '/collections/dresses-on-sale',
          'mnm': '/collections/mnm-couture',
          'portia scarlett': '/collections/portia-and-scarlett',
          'tulle': '/collections/tulle-dresses',
          'yellow': '/collections/yellow-dresses',
          'red carpet': '/collections/red-carpet-dresses',
          'red carpet dress': '/collections/red-carpet-dresses',
          'red carpet dresses': '/collections/red-carpet-dresses',
          'nude': '/collections/nude-dresses',
          'wholesale': '/collections/wholesale-dresses',
          'wholesale dress': '/collections/wholesale-dresses',
          'wholesale dresses': '/collections/wholesale-dresses',
          'lavender': '/collections/lavender-dresses',
          'maxi': '/collections/maxi-dresses',
          'special occasion': '/collections/special-occasion-dresses',
          'special occasion dress': '/collections/special-occasion-dresses',
          'special occasion dresses': '/collections/special-occasion-dresses',
          'maxi dress': '/collections/maxi-dresses',
          'maxi dresses': '/collections/maxi-dresses',
          'pantsuit': '/collections/pant-suits-for-women',
          'midi': '/collections/tea-length-dresses',
          'baby blue': '/collections/baby-blue-dresses',
          'layla k': '/collections/layla-k-dresses',
          'layla k dresses': '/collections/layla-k-dresses',
          'champagne long dress': '/collections/champagne-long-dresses-elegant-styles-for-every-event?pf_opt_color=Champagne',
          'black evening gown': '/collections/long-black-dresses?pf_opt_color=Black',
          'accessories': '/collections/accessories',
          'emerald green': '/collections/emerald-green-dresses',
          'black and gold': '/collections/black-and-gold-dresses',
          'black gowns': '/collections/long-black-dresses?pf_opt_color=Black',
          'black gown': '/collections/long-black-dresses?pf_opt_color=Black',
          'beaded black dress': '/collections/beaded-dresses?pf_opt_color=Black',
          'sage ball gown': '/collections/sage-ball-gowns',
          'sage ball gowns': '/collections/sage-ball-gowns',
          'formal dresses': '/collections/formal-gowns',
          'formal dress': '/collections/formal-gowns',
          'formal gowns': '/collections/formal-gowns',
          'formal gown': '/collections/formal-gowns',
          'formal dress for women': '/collections/formal-gowns',
          'dresses': '/collections/evening-gowns',
          'dress': '/collections/evening-gowns',
          'royal queen': '/collections/royal-queen',
          'royal queen dress': '/collections/royal-queen',
          'royal queen dresses': '/collections/royal-queen',
          'ladivine': '/collections/ladivine-by-cinderella-divine',
          'cinderella divine': '/collections/ladivine-by-cinderella-divine',
          'off shoulder': '/collections/off-the-shoulder-dresses',
          'off the shoulder': '/collections/off-the-shoulder-dresses',
          'off shoulder dress': '/collections/off-the-shoulder-dresses',
          'off shoulder dresses': '/collections/off-the-shoulder-dresses',
          'off the shoulder dress': '/collections/off-the-shoulder-dresses',
          'off the shoulder dresses': '/collections/off-the-shoulder-dresses',
          'long prom dress': '/collections/long-prom-dresses',
          'long prom dresses': '/collections/long-prom-dresses',
          'sequin dress': '/collections/sequins-dresses',
          'sequin': '/collections/sequins-dresses',
          'sequin dresses': '/collections/sequins-dresses',
          'amarra': '/collections/portia-and-scarlett',
          'feather dress': '/collections/feather-dresses',
          'feather dresses': '/collections/feather-dresses',
          'amelia couture': '/collections/amelia-couture',
          'amelia': '/collections/amelia-couture',
          'quince': '/collections/quinceanera-dresses',
          'quinceanera': '/collections/quinceanera-dresses',
          'quince dress': '/collections/quinceanera-dresses',
          'vestidos de 15 años': '/collections/quinceanera-dresses',
          'sweet 16': '/collections/sweet-16-dresses',
          'pant suit': '/collections/pant-suits-for-women',
          'andrea and leo': '/collections/andrea-and-leo-dresses',
          'men': '/collections/groomsmen-suits',
          'terani': '/collections/terani-couture',
          'terani couture': '/collections/terani-couture',
          'olive': '/collections/olive-green-dresses',
          'deklaire': '/collections/deklaire-bridal',
          'black dress short': '/collections/short-black-dress?pf_opt_color=Black',
          'embroidered': '/collections/embroidered-dresses',
          'ball gown': '/collections/ball-gowns',
          'ballgown': '/collections/ball-gowns',
          'ball gowns': '/collections/ball-gowns',
          'j871': '/products/ladivine-prom-dress-long-formal-evening-gown-j871',
          'prom': '/collections/prom-dresses',
          'mother of the bride': '/collections/mother-of-the-bride-dresses',
          'mother of the bride long': '/collections/mother-of-the-bride-long-dresses',
          'cd803': '/products/ladivine-prom-dress-off-shoulder-long-beaded-formal-evening-gown-cd803',
          'long sleeve': '/collections/long-sleeve-dresses',
          'long sleeves': '/collections/long-sleeve-dresses',
          'pink': '/collections/pink-dresses?pf_opt_color=Dusty+Pink&pf_opt_color=Blush&pf_opt_color=Desert+Rose&pf_opt_color=DESERT+ROSE&pf_opt_color=DUSTY+ROSE&pf_opt_color=Dusty-Rose&pf_opt_color=Fuchsia&pf_opt_color=Fuschia&pf_opt_color=Pink&pf_opt_color=Peach',
          'blush': '/collections/blush-dresses?pf_opt_color=Blush',
          'blush dress': '/collections/blush-dresses?pf_opt_color=Blush',
          'blush dresses': '/collections/blush-dresses?pf_opt_color=Blush',
          'blue': '/collections/blue-dresses',
          'purple': '/collections/purple-dresses',
          'purple dress': '/collections/purple-dresses',
          'royal blue': '/collections/royal-blue-formal-dresses?pf_opt_color=Royal+Blue',
          'homecoming': '/collections/homecoming-dresses',
          'home coming': '/collections/homecoming-dresses',
          'gold': '/collections/gold-dresses?pf_opt_color=Gold&pf_opt_color=Rose+Gold&pf_opt_color=Rose+gold',
          'gold dress': '/collections/gold-dresses?pf_opt_color=Gold&pf_opt_color=Rose+Gold&pf_opt_color=Rose+gold',
          'gold dresses': '/collections/gold-dresses?pf_opt_color=Gold&pf_opt_color=Rose+Gold&pf_opt_color=Rose+gold',
          'sage': '/collections/sage-dresses?pf_opt_color=Sage&pf_opt_color=SAGE',
          'sage dress': '/collections/sage-dresses',
          'jovani': '/collections/jovani-dresses',
          'rose gold': '/collections/rose-gold-dresses',
          'black dress': '/collections/black-dresses?pf_opt_color=Black',
          'black evening': '/collections/black-dresses?pf_opt_color=Black',
          'black': '/collections/black-dresses?pf_opt_color=Black',
          'new collection': '/collections/new-arrivals',
          'plus cocktail': '/collections/plus-size-cocktail-dresses',
          'cocktail dress': '/collections/cocktail-dresses',
          'cocktail dresses': '/collections/cocktail-dresses',
          'cocktail': '/collections/cocktail-dresses',
          'may queen evening gowns': '/collections/may-queen',
          'dusty blue': '/collections/dusty-blue-dresses?pf_opt_color=Dusty+blue',
          'mermaid dresses': '/collections/mermaid-dresses',
          'mermaid gown': '/collections/mermaid-dresses',
          'sage green': '/collections/sage-dresses?pf_opt_color=Sage&pf_opt_color=SAGE',
          'champagne': '/collections/champagne-dresses',
          'red': '/collections/red-dresses?pf_opt_color=Red',
          'blue dress': '/collections/blue-dresses',
          'floral': '/collections/floral-dresses',
          'green': '/collections/green-dresses?pf_opt_color=Green',
          'white': '/collections/white-dresses?pf_opt_color=White',
          'dancing queen': '/collections/dancing-queen-dresses',
          'gold dresses': '/collections/gold-dresses?pf_opt_color=Gold&pf_opt_color=Rose+Gold&pf_opt_color=Rose+gold',
          'dancing queen': '/collections/dancing-queen-dresses',
          'champagne dress': '/collections/champagne-dresses?pf_opt_color=Champagne',
          'dama dresses for quinceanera': '/collections/dama-dresses',
          'may queen': '/collections/may-queen',
          'lilac': '/collections/lilac-dresses?pf_opt_color=LILAC&pf_opt_color=Lilac',
          'red dress': '/collections/red-dresses?pf_opt_color=Red',
          'royal quinceanera': '/collections/royal-blue-quinceanera-dresses?pf_opt_color=Royal+Blue',
          'royal quinceanera dress': '/collections/royal-blue-quinceanera-dresses?pf_opt_color=Royal+Blue',
          'royal blue quinceanera dress': '/collections/royal-blue-quinceanera-dresses?pf_opt_color=Royal+Blue',
          'purple dresses plus size': '/collections/purple-plus-size-dresses?pf_opt_color=Purple',
          'silver dress': '/collections/silver-dresses',
          'silver dresses': '/collections/silver-dresses',
          'silver': '/collections/silver-dresses?pf_opt_color=Silver',
          'silver formal dress': '/collections/silver-dresses?pf_opt_color=Silver',
          'silver gown': '/collections/silver-dresses?pf_opt_color=Silver',
          'jumpsuit': '/collections/jumpsuits',
          'jumpsuits': '/collections/jumpsuits',
          'portia and scarlett': '/collections/portia-and-scarlett',
          'portia & scarlett': '/collections/portia-and-scarlett',
          'portia': '/collections/portia-and-scarlett',
          'navy blue': '/collections/navy-dresses?pf_opt_color=Navy+Blue',
          'prom dress': '/collections/prom-dresses',
          'prom dresses': '/collections/prom-dresses',
          'mother of bride': '/collections/mother-of-the-bride-dresses',
          'elizabeth': '/collections/elizabeth-k',
          'apple red': '/collections/red-dresses?pf_opt_color=Red',
          'bright red': '/collections/red-dresses?pf_opt_color=Red',
          'homecoming dresses': '/collections/homecoming-dresses',
          'mermaid dress': '/collections/mermaid-dresses',
          'velvet': '/collections/velvet-dresses',
          'long sleeve dress': '/collections/long-sleeve-dresses',
          'long sleeve gown': '/collections/long-sleeve-dresses',
          'pant suits': '/collections/pant-suits-for-women',
          'pink dresses':
            '/collections/pink-dresses?pf_opt_color=Dusty+Pink&pf_opt_color=Blush&pf_opt_color=Desert+Rose&pf_opt_color=DESERT+ROSE&pf_opt_color=DUSTY+ROSE&pf_opt_color=Dusty-Rose&pf_opt_color=Fuchsia&pf_opt_color=Fuschia&pf_opt_color=Pink&pf_opt_color=Peach',
          'white dresses': '/collections/white-dresses?pf_opt_color=White',
          'white dress': '/collections/white-dresses?pf_opt_color=White',
          'corset': '/collections/corset-dresses',
          'lenovia': '/collections/lenovia-dresses',
          'feather': '/collections/feather-dresses',
          'mother of the bride long formal dress': '/collections/mother-of-the-bride-long-dresses',
          'cinderella': '/collections/ladivine-by-cinderella-divine',
          'mini dress': '/collections/short-dresses',
          'short dresses': '/collections/short-dresses',
          'mermaid': '/collections/mermaid-dresses',
          'mauve': '/collections/mauve-dresses',
          'mauve dress': '/collections/mauve-dresses',
          'mauve dresses': '/collections/mauve-dresses',
          'gala': '/collections/gala-dresses',
          'mother of the bride dresses': '/collections/mother-of-the-bride-dresses',
          'mother of the bride dress': '/collections/mother-of-the-bride-dresses',
          'mother of the groom': '/collections/mother-of-the-bride-dresses',
          'mother of the bride evening gown': '/collections/mother-of-the-bride-dresses',
          'wedding dress with train': '/collections/wedding-dresses-with-train',
          'pink dress':
            '/collections/pink-dresses?pf_opt_color=Dusty+Pink&pf_opt_color=Blush&pf_opt_color=Desert+Rose&pf_opt_color=DESERT+ROSE&pf_opt_color=DUSTY+ROSE&pf_opt_color=Dusty-Rose&pf_opt_color=Fuchsia&pf_opt_color=Fuschia&pf_opt_color=Pink&pf_opt_color=Peach',
          'wedding dresses': '/collections/wedding-dresses',
          'wedding dress': '/collections/wedding-dresses',
          'wedding': '/collections/wedding-dresses',
          'short dress': '/collections/short-dresses',
          'short': '/collections/short-dresses',
          'terani mother': '/collections/terani-mother-of-the-bride-dresses',
          'terani couture mother of the bride': '/collections/terani-mother-of-the-bride-dresses',
          'overskirt': '/collections/overskirt-dresses',
          'dusty rose': '/collections/dusty-rose-dresses?pf_opt_color=Desert+Rose',
          'pageant': '/collections/pageant-dresses',
          'night dress': '/collections/evening-gowns',
          'damas dresses': '/collections/dama-dresses',
          'eva usa': '/collections/eva-usa',
          'eva': '/collections/eva-usa',
          'champagne gold': '/collections/champagne-dresses?pf_opt_color=Champagne',
          'burgundy quince': '/collections/burgundy-quinceanera-dresses?pf_opt_color=Burgundy',
          'burgundy': '/collections/burgundy-dresses?pf_opt_color=Merlot&pf_opt_color=Burgundy&pf_opt_color=Burgundy+Gold&pf_opt_color=Burgundy+Nude&pf_opt_color=Maroon&pf_opt_color=Wine&pf_t_length=Long+Dress&pf_t_length=Short+Dress&pf_t_length=High+Low+dress&pf_t_length=Tea+Length+Dress',
          'burgundy dresses': '/collections/burgundy-dresses?pf_opt_color=Burgundy',
          'burgundy dress': '/collections/burgundy-dresses?pf_opt_color=Burgundy',
          'sienna': '/collections/sienna-dresses?pf_opt_color=Sienna&pf_opt_color=Rust',
          'brown': '/collections/brown-dresses',
          'brown dress': '/collections/brown-dresses',
          'prom gown': '/collections/prom-dresses',
          'prom gowns': '/collections/prom-dresses'
        };
        const path = window.location.pathname;
        const params = new URLSearchParams(window.location.search);
        const q = params.get('q');

        if (path === '/search' && q) {
          const target = redirects[q.toLowerCase()];
          if (target) {
            window.location.replace(target);
          }
        }
})();
